import {
  memo,
  useCallback,
  type JSX,
  type MouseEventHandler,
  useRef,
} from "react";

import { WhacamoleButton, type WhacamoleButtonProps } from "./whacamole-button";

export type ButtonProps = WhacamoleButtonProps;

function Button({ children, onClick, ...props }: ButtonProps): JSX.Element {
  const lastClickRef = useRef<number>(0);

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (e) => {
      const now = Date.now();
      const elapsed = now - lastClickRef.current;
      if (elapsed < 2e3 || e.detail > 1) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      lastClickRef.current = now;
      if (onClick) {
        onClick(e);
      }
    },
    [onClick],
  );
  return (
    <WhacamoleButton {...props} onClick={handleClick}>
      {children}
    </WhacamoleButton>
  );
}

const MemoizedButton = memo(Button);
export { MemoizedButton as Button };
